// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5587":"b3fad0ee","6526":"0c7a08a1","7755":"c05894b7"}[chunkId] + ".chunk.css";
};